import React, {useEffect} from "react";
import useStore from "./useStore";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import axios from "axios";
import swal from "sweetalert";
import {useNavigate} from "react-router-dom";

export default function () {
  const {storeFields, handleSubmit, setData, setErrors} = useStore();
  const navigate = useNavigate();

  const addStore = data => {
    axios.post('shop-addresses', data).then(function (res) {
      if (res.status == 200) {
        swal('Shop "' + data.name + '" has been created successfully!', {
          icon: "success",
        });
        navigate("/stores");
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }

  useEffect(() => {
    axios.get('shop-addresses/create')
      .then(res => {
        setData(res.data);
      });
  }, []);

  return (
    <Card title="Add Store">
      <form className="form w-100" onSubmit={handleSubmit(addStore)}>
        {storeFields}
        <SubmitButton title="Add" classes='mt-3'/>
      </form>
    </Card>
  );
}